export const QUADRO_PESSOAL_LIST = 'QUADRO_PESSOAL_LIST';
export const QUADRO_PESSOAL_LIST_START = 'QUADRO_PESSOAL_LIST_START';
export const QUADRO_PESSOAL_LIST_SUCCESS = 'QUADRO_PESSOAL_LIST_SUCCESS';
export const QUADRO_PESSOAL_LIST_ERROR = 'QUADRO_PESSOAL_LIST_ERROR';

export const RESET_QUADRO_PESSOAL = 'RESET_QUADRO_PESSOAL';
